import { AuthLayoutTemplate } from 'shared/ui/AuthLayoutTemplate';

import { CompleteFormWrapper } from './CompleteFormWrapper';

export type CompleteProfileProps = {
  showCompanyField: boolean;
};

export const CompleteProfile = ({ showCompanyField }: CompleteProfileProps) => {
  return (
    <AuthLayoutTemplate pageName="CompleteProfile">
      <CompleteFormWrapper showCompanyField={showCompanyField} />
    </AuthLayoutTemplate>
  );
};
